var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0086 20.9951L7.00862 21.0046C4.80862 21.0066 3.00712 19.2086 3.00462 17.0086L2.99512 7.00862C2.99312 4.80862 4.79112 3.00712 6.99112 3.00462L16.9911 2.99512C19.1911 2.99312 20.9926 4.79112 20.9951 6.99112L21.0046 16.9911C21.0071 19.1916 19.2086 20.9931 17.0086 20.9951Z",
    fill: "url(#paint0_radial_509_745)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0086 20.9951L7.00862 21.0046C4.80862 21.0066 3.00712 19.2086 3.00462 17.0086L2.99512 7.00862C2.99312 4.80862 4.79112 3.00712 6.99112 3.00462L16.9911 2.99512C19.1911 2.99312 20.9926 4.79112 20.9951 6.99112L21.0046 16.9911C21.0071 19.1916 19.2086 20.9931 17.0086 20.9951Z",
    fill: "url(#paint1_radial_509_745)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C10.0705 15.5 8.5 13.93 8.5 12C8.5 10.07 10.0705 8.5 12 8.5C13.9295 8.5 15.5 10.07 15.5 12C15.5 13.93 13.9295 15.5 12 15.5ZM12 9.5C10.6215 9.5 9.5 10.6215 9.5 12C9.5 13.3785 10.6215 14.5 12 14.5C13.3785 14.5 14.5 13.3785 14.5 12C14.5 10.6215 13.3785 9.5 12 9.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9C16.1642 9 16.5 8.66421 16.5 8.25C16.5 7.83579 16.1642 7.5 15.75 7.5C15.3358 7.5 15 7.83579 15 8.25C15 8.66421 15.3358 9 15.75 9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5H9C7.0705 18.5 5.5 16.93 5.5 15V9C5.5 7.07 7.0705 5.5 9 5.5H15C16.9295 5.5 18.5 7.07 18.5 9V15C18.5 16.93 16.9295 18.5 15 18.5ZM9 6.5C7.6215 6.5 6.5 7.6215 6.5 9V15C6.5 16.3785 7.6215 17.5 9 17.5H15C16.3785 17.5 17.5 16.3785 17.5 15V9C17.5 7.6215 16.3785 6.5 15 6.5H9Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_509_745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.69012 21.0176) scale(22.4495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_509_745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.89312 2.77027) scale(14.9065 9.9322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.dbcfca19fa1cfe74b003e6e76ec59e1d.svg";
export { ForwardRef as ReactComponent };